import React, { useState } from 'react'
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import CustomerComment from '../CustomerComment'
import { TabTitle } from '../../../../util/titleChanger'
import { GlobalState } from '../../../../GlobalState'
import { useEffect } from 'react';
import Loading from '../../../../util/Loading'
import { ToastContainer, toast } from 'react-toastify';
import { createCusFeedback, getAllCusFeedbackById } from '../../../../action';

export default function CustomerFeedbackForm() {
    TabTitle("Customer Comment");
    const { cusId } = useParams();

    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    //Local State
    const [values, setValues] = useState({});
    const [focused, setFocused] = useState(false);

    //Import customer comment from global state
    const [cusFeedbackData, setCusFeedbackData] = useState([]);
    const [cusFeedbacks] = state.customerFeedbackAPI.cusFeedbacks
    const [callback, setCallback] = state.customerFeedbackAPI.callback;

    //Import customer state from global state
    const [allCustomers] = state.customerAPI.allCustomers;
    const [showCustomerSuggestions, setShowCustomerSuggestions] = useState(false);
    const [selectCustomer, setSelectCustomer] = useState("");
    const customerSuggestions = allCustomers.filter(customer =>
        customer.first_name.toString().toLowerCase().includes(selectCustomer.toString().toLowerCase())
    )

    const onChangeValue = (e) => {
        e.preventDefault();
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    const handleCustomerSuggestionClick = (suggestion) => {
        setSelectCustomer(suggestion.first_name + " " + suggestion.last_name)
        setShowCustomerSuggestions(false)
        setValues({
            ...values,
            customerId: suggestion.id
        })
    }

    const onChangeSelectCustomer = (e) => {
        setSelectCustomer(e.target.value)
    }

    const handleFocus = (e) => {
        setFocused(false);
    }

    useEffect(() => {
        cusFeedbacks ? setCusFeedbackData(cusFeedbacks) : setCusFeedbackData([]);
        if (cusId > 0) {
            getAllCusFeedbackById(cusId, res => {
                setCusFeedbackData(res)
            })
        }
    }, [allCustomers, cusFeedbacks])

    const submitDefault = (e) => {
        e.preventDefault();

        const feedbackInfo = {
            note: values.note,
            customerId: values.customerId,
            updatedBy: signInUser.id,
            createdBy: signInUser.id
        }

        createCusFeedback(feedbackInfo, res => {
            if (res.status === 200) {
                setCallback(!callback)
                setCusFeedbackData(cusFeedbacks)
                toast.success(res.data)
            } else {
                setCallback(!callback)
                toast.error(res.data)
            }
        })
    }

    return (
        !cusFeedbacks ? <div className="form-container"><div className="loading-page-container"><Loading /></div></div>
            : <div className="form-container">
                <form onSubmit={submitDefault} className="form">
                    <div className="input-box">
                        <label>Customer Name</label>
                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search here....'
                            value={selectCustomer}
                            onBlur={handleFocus}
                            focused={focused.toString()}
                            onChange={onChangeSelectCustomer}
                            onFocus={() => setShowCustomerSuggestions(true)}
                        />
                        {
                            showCustomerSuggestions && (
                                <ul className="suggestions">
                                    {
                                        customerSuggestions.map(suggestion => (
                                            <li key={suggestion.id} onClick={() => handleCustomerSuggestionClick(suggestion)}>
                                                {suggestion.first_name + " " + suggestion.last_name}
                                            </li>
                                        ))
                                    }
                                </ul>
                            )
                        }
                    </div>
                    <div className="input-box">
                        <textarea
                            name="note"
                            id="note"
                            cols="30" rows="5"
                            placeholder='Enter feedback here...'
                            value={values.note || ""}
                            onChange={onChangeValue}
                        />
                    </div>
                    <div className="form-button">
                        <button className="add_new">Submit</button>
                    </div>
                </form>
                <ToastContainer />
                {
                    cusFeedbackData.status === 200 ? cusFeedbackData.data.data.map(feedback => (
                        <div key={feedback.id}>
                            <CustomerComment feedback={feedback} />
                        </div>

                    ))
                        : <div></div>
                }
            </div>
    )
}
